import type { ConfirmOptions } from "material-ui-confirm"

type TranslateConfirmDeleteButton = (
  key: "button.cancel" | "button.delete"
) => string

/** Shared dialog chrome for admin confirm-delete prompts. */
export const getAdminConfirmDeleteDialogDefaults = (
  t: TranslateConfirmDeleteButton
): ConfirmOptions => ({
  confirmationText: t("button.delete"),
  cancellationText: t("button.cancel"),
  confirmationButtonProps: {
    color: "error",
    variant: "contained",
  },
  cancellationButtonProps: {
    color: "primary",
    variant: "text",
  },
  // Relax enforced focus to avoid focus trap recursion in jsdom.
  dialogProps: {
    disableEnforceFocus: true,
  },
})
